"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isExternalChatOrganizationSuggestion(object) {
    return checkExternalChatOrganizationSuggestion(object).fulfilled;
}
exports.isExternalChatOrganizationSuggestion = isExternalChatOrganizationSuggestion;
function checkExternalChatOrganizationSuggestion(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasString("userId"), __1.hasString("organizationName"), __1.hasString("organizationCity"), __1.hasNumber("createdTimestamp")).withOptions(options).explain();
}
exports.checkExternalChatOrganizationSuggestion = checkExternalChatOrganizationSuggestion;
//# sourceMappingURL=ExternalChatOrganizationSuggestion.js.map